import { createAction, props } from '@ngrx/store';
import { CardStatement } from 'src/app/models/card-account-statement.model';
import { CardActiveInstalmentAgreements } from 'src/app/models/card-active-instalment-agreements.model';
import { InstalmentAgreementDetails } from 'src/app/models/card-instalment-agreement-details.model';
import { CardInstalmentAgreements } from 'src/app/models/card-instalment-agreements.model';
import { CardStatementsFilter } from 'src/app/models/card-statements-filter.model';
import { CardTransaction } from 'src/app/models/card-transaction.model';
import { Card } from 'src/app/models/card.model';
import { TransactionHistoryList } from './../../../models/transaction-history.model';

// Page Actions
export const layoutSelectActiveCard = createAction(
  '[Layout Component] Active card selection',
  props<{ selectedCard: Card | null }>()
);

export const cardsComponentSelectActiveCard = createAction(
  '[Cards Component] Active card selection',
  props<{ selectedCard: Card | null }>()
);

export const loadTransactionHistorySuccess = createAction(
  '[Card Transactions Component] Load card transactions history success',
  props<{ cardTransactions: CardTransaction | null }>()
);

export const loadTransactionHistoryFailure = createAction(
  '[Card Transactions Component] Load card transactions history Failure',
  props<{ error: any }>()
);

export const setCardTransactionDetails = createAction(
  '[Account Transaction History] Set Active Account Transaction',
  props<{ cardTransactionDetails: TransactionHistoryList | null }>()
);

export const setCardInstalAgreementDetails = createAction(
  '[Card Instal Agreements Detail] Set Instal Agreements',
  props<{ cardInstalAgreementsDetails: InstalmentAgreementDetails | null }>()
);

export const loadCardAccStatementsSuccess = createAction(
  '[Card Statements Component] Load card statements success',
  props<{ cardAccStatements: CardStatement[] | null }>()
);
export const resetCardAccStatements = createAction(
  '[Card Statements Component] Reset Card statements'
);

export const loadCardAccStatementsFailure = createAction(
  '[Statements Effect] Statements load Failure',
  props<{ error: any }>()
);

export const cardFilterStatements = createAction(
  '[Cards Filter Statements] Filter card statements',
  props<{ cardStatementsFilters: CardStatementsFilter }>()
);

export const resetFilterStatements = createAction(
  '[Card Filter Statements] Reset filter card statements'
);

export const loadInstalmentAgreementsSuccess = createAction(
  '[Card Instalment Agreements Component] Load card instalment agreements success',
  props<{ instalmentAgreements: CardInstalmentAgreements | null }>()
);

export const loadInstalmentAgreementsFailure = createAction(
  '[Card Instalment Agreements Component] Load card instalment agreements Failure'
);

export const loadActiveInstalmentAgreementsSuccess = createAction(
  '[Card Active Instalment Agreements Component] Load card active instalment agreements success',
  props<{ activeInstalmentAgreements: CardActiveInstalmentAgreements | null }>()
);

export const loadActiveInstalmentAgreementsFailure = createAction(
  '[Card Active Instalment Agreements Component] Load card active instalment agreements Failure',
  props<{ error: any }>()
);

// API Actions
export const loadTransactionHistoryApi = createAction(
  '[Card Transactions Component API] Load card transactions history'
);

export const loadCardAccStatementsApi = createAction(
  '[Card Statements Component API] Load card statements'
);

export const loadInstalmentAgreementsApi = createAction(
  '[Card Instalment Component API] Load card instalment agreements'
);

export const loadActiveInstalmentAgreementsApi = createAction(
  '[Card Active Instalment Component API] Load card active instalment agreements'
);
